import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import {
  getIsCollectionsDataPending,
  getCollectionsError,
  getActiveLayoutGroup,
  getAvailableLayoutGroups,
  getActiveLayout,
} from '../../store/selectors/collections.selectors';
import {
  setSelectedLayoutGroup,
} from '../../store/actions/collections.actions';

class PLPHero extends Component {
  constructor(props) {
    super(props);

    this.prefix = (props.plp || (props.availableLayoutGroups.length > 1)) ? 'hero-plp' : 'hero-new';
    this.renderBreadcrumbs = this.renderBreadcrumbs.bind(this);
    this.renderLayoutButtons = this.renderLayoutButtons.bind(this);
  }

  renderBreadcrumbs(collectionName) {
    let url = '';
    let urlName = '';
    if (
      collectionName && (
        collectionName.includes('nomad-leather')
        || collectionName.includes('nomad-fabric')
        || collectionName.includes('original')
        || collectionName.includes('furniture')
      )
    ) {
      url = '/furniture-collections';
      urlName = 'Seating';
    }
    return url ? (
      <p className={`${this.prefix}-breadcrumbs`}>
        <Link to={url}>{urlName}</Link>/
      </p>
    ) : null;
  }

  static getLayoutButtonMetadata(layoutGroup) {
    switch (layoutGroup) {
      case 'GRID':
        return {
          layoutGroup,
          label: 'Grid',
          icon: 'icon-grid',
        };

      case 'CAROUSEL':
        return {
          layoutGroup,
          label: 'Swipe',
          icon: 'icon-swipe',
        };

      default:
        return {
          layoutGroup,
        };
    }
  }

  renderLayoutButtons() {
    const {
      anchor,
      availableLayoutGroups,
      activeLayoutGroup,
      setSelectedLayoutGroupAction,
    } = this.props;

    if (!(Array.isArray(availableLayoutGroups) && availableLayoutGroups.length > 1)) {
      return null;
    }

    return (
      <div id={anchor || undefined} className="hero-plp-layout-buttons">
        {availableLayoutGroups
          .map(PLPHero.getLayoutButtonMetadata)
          .map(({
            layoutGroup,
            label,
            icon,
          }) => (
            <div
              key={layoutGroup}
              className="hero-plp-layout-button"
              onClick={() => setSelectedLayoutGroupAction(layoutGroup)}
            >
              <i className={classNames('layout-icons', icon, { active: activeLayoutGroup === layoutGroup })} />
              <div className="hero-plp-layout-button-label body-large">
                {label}
              </div>
            </div>
          ))
        }
      </div>
    );
  }

  render() {
    return (
      <section className={`${this.prefix}${this.props.center ? ' mobile-center' : ''}`}>
        {this.renderBreadcrumbs(this.props.page)}
        <div className={`${this.prefix}-header-wrapper`}>
          <h2
            className={classNames(`${this.prefix}-header`, 'h1', {
              outline: this.props.header === 'Showrooms',
              [`${this.prefix}-header-margin`]: !this.props.breadCrumbs,
            })}
          >
            {this.props.header}
          </h2>
          {this.renderLayoutButtons()}
        </div>
        <p className="wrap">{this.props.subHeader}</p>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  isCollectionsDataPending: getIsCollectionsDataPending(state),
  error: getCollectionsError(state),
  availableLayoutGroups: getAvailableLayoutGroups(state),
  activeLayoutGroup: getActiveLayoutGroup(state),
  activeLayout: getActiveLayout(state),
});

const mapDispatchToProps = {
  setSelectedLayoutGroupAction: setSelectedLayoutGroup,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
)(PLPHero);
